// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b0dj2","col":"styles_col__1Q0GD"};